module.exports = __webpack_public_path__ + "img/Malaysia.409843db.jpg";